import { Fragment, memo } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { fullName, fullAddress } from "../../functions/users";
import { useIntl } from "react-intl";

const NoUser = () => (
  <Fragment>
    <Typography variant="body1" gutterBottom>
      Profile
    </Typography>
    <div>No user available</div>
  </Fragment>
);

const SimpleProfile = memo(function SimpleProfile({ currentUser }) {
  const { formatMessage } = useIntl();

  if (!currentUser) {
    return <NoUser />;
  }

  const { address } = currentUser;
  const userFullName = fullName(currentUser, " ");
  const addressLine = fullAddress(address);

  return (
    <Fragment>
      <Grid container spacing={24} style={{ textAlign: "center" }}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5">
            {formatMessage({ id: "profile.header.headline" })}
          </Typography>
          <Typography variant="h5">{userFullName}</Typography>
          <Typography variant="subtitle1" style={{ marginBottom: "20px" }}>
            {addressLine}
          </Typography>
          <Typography component="p">
            {formatMessage({ id: "profile.header.paragraph" })}
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
});

export default SimpleProfile;
